import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { packageOrderNeedsPayment } from "@whoosh/features/src/Packages";

import { useGetOutstandingOrders_memberPackage$key } from "./__generated__/useGetOutstandingOrders_memberPackage.graphql";

export const useGetOutstandingOrders = (
  memberPackageRef?: useGetOutstandingOrders_memberPackage$key | null
) => {
  const memberPackage = useFragment(
    useGetOutstandingOrdersFragmentString,
    memberPackageRef
  );

  const orders =
    memberPackage?.orders?.edges?.flatMap((edge) =>
      edge?.node ? [edge.node] : []
    ) || [];

  return (
    orders.flatMap((order) => {
      const needsPayment = packageOrderNeedsPayment(order);
      return needsPayment ? [order.id] : [];
    }) ?? []
  );
};

const useGetOutstandingOrdersFragmentString = graphql`
  fragment useGetOutstandingOrders_memberPackage on MemberPackage {
    orders {
      edges {
        node {
          id
          ...packageOrderNeedsPayment_order
        }
      }
    }
  }
`;
